import { getLeasedEquipmentSupplyAlertProfile } from "actions/CarrierAgreementMgmt/LeasedEquipment";
import { useQuery } from "react-query";

export const useGetSupplyAlertProfile = () => {
  return useQuery(
    "GetLeasedEquipmentSupplyAlertProfile",
    getLeasedEquipmentSupplyAlertProfile,
    {
      refetchOnWindowFocus: false,
    }
  );
};
